export default __webpack_public_path__ + "static/definition-icon-1ecb21bd1e1af716bf20d73dec860789.svg";